import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React from 'react';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

/**
 * `Paragraph` is a block containing a single paragraph of [Text](#!/Text).
 * @since 1.1.0
 */
var Paragraph = function Paragraph(_ref) {
  var _ref$baseClassName = _ref.baseClassName,
      baseClassName = _ref$baseClassName === void 0 ? "".concat(CLS_PREFIX, "paragraph") : _ref$baseClassName,
      className = _ref.className,
      children = _ref.children,
      _ref$component = _ref.component,
      Tag = _ref$component === void 0 ? 'p' : _ref$component,
      props = _objectWithoutProperties(_ref, ["baseClassName", "className", "children", "component"]);

  return React.createElement(Tag, _extends({
    className: classNames(baseClassName, className)
  }, props), children);
};

export default Paragraph;